<template>
  <div class="div p4p-form">
    <div class="form border">
      <div class="p-3">
        <div class="inline-form">
          <div>
            <label>Unit:</label>
            <a-select
              :value="unit"
              @change="(value) => updateForm('unit', value)"
            >
              <a-select-option :value="0"> All </a-select-option>
              <a-select-option
                v-for="company in authorizedClients"
                :value="company.clientId"
                :key="company.clientId"
              >
                {{ company.clientName }}
              </a-select-option>
            </a-select>
          </div>
          <div>
            <label>Period:</label
            ><a-select
              :options="periodOptions"
              :value="period"
              @change="(value) => updateForm('period', value)"
            />
          </div>
          <div>
            <label>Date Range:</label>
            <a-range-picker
              :value="dateRange"
              @change="(value) => updateForm('dateRange', value)"
              format="MM/DD/YYYY"
              :allowClear="false"
            />
          </div>
        </div>
        <a-spin :spinning="status === 'generating'" v-if="generatedReport">
          <div class="card-container">
            <div class="card green">
              <div class="card-body">
                <div class="card-image">
                  <font-awesome-icon icon="certificate" />
                </div>
                <span>{{
                  parseInt(
                    Math.round(generatedReport.averagePointsAwardedPerUser)
                  ).toLocaleString()
                }}</span>
              </div>
              <div class="card-desc">Average Points Awarded per User</div>
            </div>
            <div class="card orange">
              <div class="card-body">
                <div class="card-image"><font-awesome-icon icon="users" /></div>
                <span>{{
                  parseInt(
                    Math.round(generatedReport.loginsCount)
                  ).toLocaleString()
                }}</span>
              </div>
              <div class="card-desc">Logins</div>
            </div>
            <div class="card yellow">
              <div class="card-body">
                <div class="card-image">
                  <font-awesome-icon icon="check-circle" />
                </div>
                <span>{{
                  parseInt(
                    Math.round(generatedReport.totalPointsRedeemed)
                  ).toLocaleString()
                }}</span>
              </div>
              <div class="card-desc">Total Points Redeemed</div>
            </div>
            <div class="card blue">
              <div class="card-body">
                <div class="card-image">
                  <font-awesome-icon icon="shopping-cart" />
                </div>
                <span>{{
                  parseInt(
                    Math.round(generatedReport.orderCount)
                  ).toLocaleString()
                }}</span>
              </div>
              <div class="card-desc">Total Number of Orders Placed</div>
            </div>
            <div class="card brown">
              <div class="card-body">
                <div class="card-image"><font-awesome-icon icon="user" /></div>
                <span>{{
                  parseInt(
                    Math.round(generatedReport.userCountWhoPlacedOrder)
                  ).toLocaleString()
                }}</span>
              </div>
              <div class="card-desc">Number of Users Who Placed Orders</div>
            </div>
          </div>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "P4pDashboardForm",
  data() {
    return {
      unit: 0,
      period: 1,
      dateRange: [moment().startOf("year"), moment()],
      periodOptions: [
        { value: 0, label: "Custom", disabled: true },
        { value: 1, label: "Year-to-Date" },
        { value: 2, label: "Month-to-Date" },
        { value: 3, label: "Week-to-Date" },
        { value: 4, label: "Quarter-to-Date" },
      ],
    };
  },
  methods: {
    updateForm(propertName, propertValue) {
      this[propertName] = propertValue;
      if (propertName === "period") {
        const endDate = this.dateRange[1].clone();
        let startDate;
        console.log(propertValue);
        switch (propertValue) {
          case 1:
            startDate = endDate.startOf("year");
            break;
          case 2:
            startDate = endDate.startOf("month");
            break;
          case 3:
            startDate = endDate.startOf("week").add(1, "d");
            break;
          case 4:
            startDate = endDate.startOf("quarter");
            break;
        }

        console.log(startDate);
        this.dateRange = [startDate, this.dateRange[1]];
        console.log(this.dateRange);
      }
      if (propertName === "dateRange") {
        this.period = 0;
      }
      this.generateReport();
    },
    generateReport() {
      const payload = {
        start_date: this.dateRange[0].toDate().toISOString(),
        end_date: this.dateRange[1].toDate().toISOString(),
        client_ids:
          this.unit === 0
            ? this.authorizedClients.map(({ clientId }) => clientId)
            : [this.unit],
      };
      this.$store.dispatch("p4pDashboard/getP4PReport", payload);
    },
  },
  computed: {
    authorizedClients() {
      return this.$store.getters["p4pDashboard/getAuthorizedClients"];
    },
    status() {
      return this.$store.getters["p4pDashboard/getStatus"];
    },
    generatedReport() {
      return this.$store.getters["p4pDashboard/getGeneratedReport"];
    },
  },
  created() {
    this.$store.dispatch("p4pDashboard/fetchAuthorizedClients").then(() => {
      this.generateReport();
    });
  },
};
</script>

<style lang="scss">
.border {
  border-radius: 5px;
}

.page-heading {
  font-size: 20px;
  font-weight: 500;
}
.p4p-form {
  @mixin form-field {
    background-color: #f0f9ff !important;
    height: calc(1.5em + 1rem);
    border-radius: 0.4rem;
    border: 0 solid #ced4da !important;
    box-shadow: inset 1px 1px 3px rgb(157 193 216 / 50%);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }
  @mixin card-color($color) {
    .card-body {
      color: $color;
    }
    .card-desc {
      background-color: $color;
    }
  }
  .inline-form {
    display: flex;
    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0% 2%;
      & > div {
        width: 100%;
      }
    }
  }
  .card-container {
    display: flex;
    justify-content: space-evenly;
    margin-top: 2%;
    flex-wrap: wrap;
    .card {
      margin-bottom: 20px;
      background-color: #fff;
      border: 1px solid #337ab7;
      border-radius: 4px;
      -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
      box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
      flex-basis: 15%;
      min-width: 170px;
      text-align: center;
      &.green {
        @include card-color(green);
      }
      &.orange {
        @include card-color(#f0ad4e);
      }
      &.yellow {
        @include card-color(#ffd700);
      }
      &.blue {
        @include card-color(#7ec0ee);
      }
      &.brown {
        @include card-color(#8b4513);
      }
      .card-body {
        font-size: 30px;
      }
      .card-desc {
        padding: 10% 5%;
        color: white;
        flex-basis: 45%;
      }
    }
  }
}
</style>
